import { render, staticRenderFns } from "./booking-educators-tab.vue?vue&type=template&id=4599f30e&scoped=true&"
import script from "./booking-educators-tab.vue?vue&type=script&lang=js&"
export * from "./booking-educators-tab.vue?vue&type=script&lang=js&"
import style0 from "./booking-educators-tab.vue?vue&type=style&index=0&id=4599f30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599f30e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow})
